export default __webpack_public_path__ + "static/media/trendingUp.c79250c5.svg";